<template>
  <div>
    <b-card class="standardpage">

      <b-nav class="pt-2 ml-2 mb-2" small pills>
        <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="xhold_reset">*EVENTS*
          <span :id="'ihold_count_total'" class="ml-1 badge badge-info">{{ gtotal }}</span>
        </b-nav-item>
        <!-- {{ xholdevents }} -->
        <b-nav-item v-if="zevent.eventcode" class="nav-pills-hover-effect border-secondary" small
          v-for="(zevent, index) in xholdevents" :key="zevent"
          @click="agent = null; slac = [], eventcode = [zevent.eventcode]" :active="zevent.eventcode == eventcode[0]">
          <span :id="'event_name_' + index" :class="zevent.eventcode == '*BLOCKED*' ? 'strong text-danger' : null"
            v-html="zevent.eventcode"></span>
          <span :id="'event_count_' + index" class="ml-1 badge badge-info">{{ zevent.count }}</span>

          <span v-if="parseFloat(zevent.aged) > 0" :id="'event_aged_' + index" class="ml-1 badge badge-danger">{{
            zevent.aged }}</span>

          <b-tooltip :target="'event_name_' + index" placement="top">{{ zevent.name }}</b-tooltip>

          <b-tooltip :target="'event_count_' + index" placement="top">{{ zevent.count }} line(s) in
            total.</b-tooltip>

          <b-tooltip :target="'event_aged_' + index" placement="top">{{ zevent.aged }} charge(s) have been delayed in
            Amex Inventory for
            longer
            than a
            week!</b-tooltip>
        </b-nav-item>
      </b-nav>
      <hr />

      <b-nav class="pt-2 ml-2 mb-2" small pills>
        <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="xhold_reset">*SLACS*
          <span :id="'ihold_count_total'" class="ml-1 badge badge-info">{{ gtotal }}</span>
        </b-nav-item>
        <b-nav-item v-if="zclient.slac" class="nav-pills-hover-effect border-secondary" small
          v-for="(zclient, index) in xholdclients" :key="zclient"
          @click="agent = null; eventcode = []; slac = [zclient.slac]" :active="zclient.slac == slac[0]">
          <span :id="'slac_name_' + index" :class="zclient.slac == '*BLOCKED*' ? 'strong text-danger' : null"
            v-html="zclient.slac"></span>

          <span :id="'slac_count_' + index" class="ml-1 badge badge-info">{{ zclient.count }}</span>

          <!-- <span :id="'slac_aged_' + index" class="ml-1 badge badge-danger">{{ zclient.aged }}</span> -->
          <span v-if="parseFloat(zclient.aged) > 0" :id="'slac_aged_' + index" class="ml-1 badge badge-danger">{{
            zclient.aged }}</span>

          <b-tooltip :target="'slac_name_' + index" placement="top">{{ zclient.name }}</b-tooltip>

          <b-tooltip :target="'slac_count_' + index" placement="top">{{ zclient.count }} line(s) in
            total.</b-tooltip>

          <b-tooltip :target="'slac_aged_' + index" placement="top">{{ zclient.aged }} charge(s) have been delayed in
            Amex Inventory for
            longer
            than a
            week!</b-tooltip>

        </b-nav-item>
      </b-nav>

      <hr />

      <b-card-header class="pt-2 pb-2">
        <b-row>
          <b-col cols="auto" v-if="!xholdagents.find(o => o.agent == agent)">
            <span class="badge badge-info text-2x pt-0 pb-1 ml-0">Select an agent to view inventory
              <span v-if="user.permissions.includes('amex.admin')">
                <span v-if="status.includes('ready')">
                  <i class="fa fa-check-square-o text-primary ml-1"></i>
                  <span class="ml-1 text-white">Ready</span>
                </span>
                <span v-if="status.includes('pending')">
                  <i class="fa fa-hourglass-half text-warning ml-1"></i>
                  <span class="ml-1 text-white">Pending</span>
                </span>
              </span>
            </span>

          </b-col>
          <b-col cols="auto" class="text-right" v-else>

            <span class="badge badge-info text-2x pt-0 pb-1"> {{xholdagents.find(o => o.agent ==
              agent) ? xholdagents.find(o => o.agent == agent).name : ""}}
              <span v-if="user.permissions.includes('amex.admin')">
                <span v-if="status.includes('ready')">
                  <i class="fa fa-check-square-o text-primary ml-1"></i>
                  <span class="ml-1 text-white">Ready</span>
                </span>
                <span v-if="status.includes('pending')">
                  <i class="fa fa-hourglass-half text-warning ml-1"></i>
                  <span class="ml-1 text-white">Pending</span>
                </span>
              </span>
            </span>

          </b-col>
          <b-col class="text-right strong"> Count:
            <span id="ihold_ztotal" class="ml-1 badge badge-info text-3x pt-0 pb-1">{{ ztotal }}</span>
            <b-tooltip target="ihold_ztotal" placement="top">Total of uninvoiced xhold inventory waiting.</b-tooltip>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="mt-4 availtable datatable">
        <b-row>
          <b-col>
            <b-avatar-group v-for="(zdepartment, gindex) in departments" :key="gindex" size="34px" overlap="0"
              class="inline mr-1 mt-1 ml-2 text-center p-1 avatar_dept avatarbadge">
              <span class="text-primary pt-2 mr-1">{{ zdepartment }}</span>
              <div v-for="(zagent, index) in xholdagents.filter(a => a.department == zdepartment)" :key="index">
                <span @click="change_agent(zagent.agent)" :id="zagent.agent + '_' + zagent.department + '_1'">
                  <b-avatar class="mr-1 z-auto" :text="zagent.agent" :badge="zagent.count"
                    badge-variant="info"></b-avatar>
                </span>
                <b-tooltip :target="zagent.agent + '_' + zagent.department + '_1'" placement="bottom">{{ zagent.name }}
                </b-tooltip>
              </div>

            </b-avatar-group>
          </b-col>
        </b-row>

        <b-row class="excelsheetbuttons " no-gutters>
          <b-col>
            <span class="small text-primary">{{ message_count }}</span> </b-col>
        </b-row>

      </div>

      <div v-if="!component" class="availtable datatable">


        <b-card v-if="xhold.filter" class="w-100pct mb-3">
          <b-card-body class="py-0">

            <b-row>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group>
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :clearable="true" :multiple="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested @select="treeselect">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="datetravel" v-model="datetravel" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="false" @click="
                        datetravel = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker size="sm" v-model="datetravel" label-help hide-header locale="en-GB"
                      placeholder="Date Travel" :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"></b-form-datepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!datetravel" @click="datetravel = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-form-group label="Type" label-for="type" label-cols="12">
                  <treeselect v-model="type" :clearable="true" :multiple="true" :options="options_type"
                    placeholder="Show all..."></treeselect>
                </b-form-group> -->
                <b-form-group label-cols="12" label="Type" label-size="sm">
                  <treeselect placeholder="Show all..." searchPromptText="Supplier Type..." v-model="type"
                    :clearable="true" :multiple="true" :options="options_suppliertype">
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm" class="mb-0">
                  <b-input-group>
                    <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadBLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col> <b-form-group label="Transaction Id ( Paste List )" label-for="id" label-cols="12">
                      <b-input-group class="z-0">
                        <b-form-tags input-id="referenceno" v-model="referenceno" tag-variant="primary" separator=" ,;"
                          placeholder="Paste Transaction Id (1000,1001,1002...)" size="sm" class="h-29"
                          add-button-text="+" add-on-change remove-on-delete
                          add-button-variant="outline-primary"></b-form-tags>

                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="referenceno = []">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group></b-col>

                  <!-- <b-col>
                    <b-form-group label="ConfNo ( Paste List )" label-for="id" label-cols="12">
                      <b-input-group class="z-0">
                        <b-form-tags input-id="id" v-model="reference" tag-variant="primary" separator=" ,;"
                          placeholder="Paste ConfNo (511304589, 511304590...)" size="sm" class="h-29"
                          add-button-text="+" add-on-change remove-on-delete
                          add-button-variant="outline-primary"></b-form-tags>

                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="reference = []">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->
                </b-row>

              </b-col>



              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Cost (min)" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="cost.min" :debounce="xhold.debounce" placeholder="(min)"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!cost.min"
                            @click="cost.min = null; cost.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Cost (max)" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="cost.max" :debounce="xhold.debounce" placeholder="(max)"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!cost.max"
                            @click="cost.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3" class="display-none">
                <b-form-group label-cols="12" label="Source" label-size="sm">
                  <treeselect placeholder="Select source..." v-model="mssql" :clearable="false"
                    :options="options_source" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3" v-if="!user.permissions.includes('amex.admin')">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input size="sm" v-model="agent" placeholder="Agent" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group> </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3" v-if="user.permissions.includes('amex.admin')">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Agent" label-size="sm">
                      <b-input-group>
                        <b-form-input size="sm" v-model="agent" placeholder="Agent" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group> </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Status" label-size="sm">
                      <treeselect placeholder="Select status..." v-model="status" :multiple="true" :clearable="false"
                        :options="options_status" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <!-- {{ xhold.groupbydeployment }} -->
        <div class="px-3 mt-2 mb-2">
          <e-table classdivtable="availtable datatable w-100pct" refid="xhold" :busy="xhold.busy" :icon="xhold.icon"
            :selectmode="'none'" :showtoolbar="true" :showfab="false" :showsheets="false" :showrowcount="true"
            :showautoadd="false" :showpages="true" :offset="xhold.offset" :limit="xhold.limit" :page="xhold.page"
            :toolbarlibrary="xhold.toolbarlibrary" :tools="xhold.tools" :badges="xhold.badges" :fields="xhold.fields"
            :items="xhold.items" @click="xhold_click" @select="xhold_select" @load="xhold_load">
          </e-table>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="xhold.selected" :config="cconfig" @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"></component>
      </div>
      <b-card-footer>
        <b-row class="mt-2">
          <b-col><span class="small" v-html="message"></span> </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "Xhold",
  async mounted() {
    this.accessdenied();
    await this.xhold_reset()
  },
  watch: {
    async referenceno() {
      await this.xhold_load();
    },
    async reference() {
      await this.xhold_load();
    },
    async slac() {
      await this.xhold_load();
    },
    async blac() {
      await this.xhold_load();
    },
    async datetravel() {
      await this.xhold_load();
    },
    async type() {
      await this.xhold_load();
    },
    async eventcode() {
      await this.xhold_load();
    },
    async agent() {
      await this.xhold_load();
    },
    async status() {
      await this.xhold_load();
    },
    "cost.min": {
      immediate: true,
      async handler(newVal, oldVal) {
        if (!this.cost.max) { this.cost.max = this.cost.min }
        await this.xhold_load(0)
      }
    },
    "cost.max": {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.xhold_load(0)
      }
    },
  },

  data() {
    return {
      busy: false,
      message: "",
      gtotal: 0,
      ztotal: 0,
      xholdevents: [],
      xholdclients: [],
      xholdagents: [],
      departments: [],
      options_departments: [],
      email: "",
      agent: "",
      fullname: "",
      message_count: "",
      isblocked: "0",
      showblocked: false,
      readonly: false,
      eventcode: [],
      slac: [],
      blac: [],
      //datetravel: null,  
      datetravel: {
        startDate: null,
        endDate: null,
      },
      type: [],
      options_suppliertype: [],
      options_type: [
        { id: "AIR", label: "Air Ticketed" },
        { id: "LOW", label: "Low Cost" },
        { id: "HTL", label: "Hotels" },
        { id: "CAR", label: "Cars" },
        { id: "XFR", label: "Ground Handling" },
        { id: "RAI", label: "Rail/Eurostar" },
        { id: "BAG", label: "Baggage" },
        { id: "MTG", label: "Meetings" },
        { id: "OTH", label: "Other" },
      ],
      referenceno: [],
      reference: [],
      agent: null,
      mssql: true,
      cost: {
        min: null,
        max: null,
      },
      status: ["ready"],
      options_status: [
        { id: "ready", label: "Ready" },
        { id: "pending", label: "Pending" },
        { id: "offline", label: "Offline" },
      ],
      source: "svpconf,bcardconf",
      options_source: [
        { id: false, label: "Booking Forms" },
        { id: true, label: "API" },
      ],
      xhold: {
        title: "AMEX Charges",
        icon: "fa fa-cc-amex text-info",
        debounce: 1000,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        filter: false,
        tools: "go,filter",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-check-square-o text-primary",
            position: "toolbar",
            action: "ready",
            label: "Ready",
            component: {
              name: "",
            },
          },
        ],
        fields: [
          {
            key: "citem",
            label: "Xhold Inventory",
            type: "ixinvoice",
            class: "text-left w-90pct",
            clearable: "true",
          },
        ],
        badges: [],
        items: [],
        selected: [],
      },
    };
  },
  async mounted() {
    await this.accessdenied();
    try {
      const response = await this.$apollo.query({
        query: gql`
                        query suppliertypes {
                        suppliertypes {
                            id
                            label
                            faicon
                        }
                        }
                    `,
      });
      // this.options_suppliertype = response.data.suppliertypes;
      this.options_suppliertype = response.data.suppliertypes.filter(o => o.faicon != '');
    } catch (error) {
      console.log(error);
    }
    await this.xhold_load(0);
  },
  methods: {
    accessdenied() {
      this.xhold.denied = [];
      if (!this.user.permissions.includes("amex.delete")) {
        this.xhold.denied.push("delete");
      }
      if (!this.user.permissions.includes("amex.save")) {
        this.xhold.denied.push("save");
      }
      if (this.user.permissions.includes("amex.admin")) {
        this.xhold.tools = "go,filter,ready,pending,reset"
      }
    },
    async change_agent(agent) {
      this.agent = agent
      await this.xhold_load();
    },
    async xhold_reset() {
      let state = this.xhold;
      state.items = []
      this.eventcode = []
      this.slac = []
      this.agent = null
      this.gtotal = 0
      await this.xholdevents_load()
      await this.xholdclients_load()
      await this.xholdagents_load()
    },
    async xhold_reload() {
      await this.xholdevents_load()
      await this.xholdclients_load()
      await this.xholdagents_load()
      await this.xhold_load();
    },
    async xholdagents_load() {
      let variables = {
        type: 'byagent',
        eventcode: this.eventcode ? this.eventcode.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        slac: this.slac ? this.slac.join(",") : null,
        status: this.status.length > 0 ? this.status.join(",") : null,
        source: 'xhold',
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
                  query ihold_counts(
                      $blac: String
                      $source: String
                      $eventcode: String
                      $slac: String
                      $status: String
                      $type: String
                  ) {
                    ihold_counts(
                        blac: $blac
                        source: $source
                        eventcode: $eventcode
                        slac: $slac
                        status: $status
                        type: $type
                  ) {
                      count
                      agent
                      email
                      name
                      department
                  }
                  }
              `,
          variables,
        });

        this.xholdagents = response.data.ihold_counts;

        this.departments = [...new Set(this.xholdagents.map(a => a.department))].sort()

        this.ztotal = 0
        for (var i = 0; i < this.xholdagents.length; ++i) {
          this.ztotal += parseInt(this.xholdagents[i].count)
        }
      } catch (error) {
        console.log(error);
      }
    },
    async xholdevents_load() {
      let variables = {
        type: 'byevent',
        agent: this.agent ? this.agent : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        status: this.status.length > 0 ? this.status.join(",") : null,
        source: 'xhold',
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
                  query ihold_counts(
                      $blac: String
                      $source: String
                      $agent: String
                      $type: String
                      $status: String
                  ) {
                    ihold_counts(
                        blac: $blac
                        source: $source
                        agent: $agent
                        type: $type
                        status: $status
                  ) {
                      count
                      aged
                      eventcode
                      name
                  }
                  }
              `,
          variables,
        });

        this.xholdevents = response.data.ihold_counts;

      } catch (error) {
        console.log(error);
      }
    },
    async xholdclients_load() {
      let variables = {
        type: 'byclient',
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        agent: this.agent ? this.agent : null,
        status: this.status.length > 0 ? this.status.join(",") : null,
        source: 'xhold',
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
                  query ihold_counts(
                      $blac: String
                      $source: String
                      $agent: String
                      $status: String
                      $type: String
                  ) {
                    ihold_counts(
                        blac: $blac
                        agent: $agent
                        status: $status
                        type: $type
                        source: $source
                  ) {
                      count
                      aged
                      slac
                      name
                  }
                  }
              `,
          variables,
        });

        this.xholdclients = response.data.ihold_counts;

        this.ztotal = 0
        for (var i = 0; i < this.xholdclients.length; ++i) {
          this.ztotal += parseInt(this.xholdclients[i].count)
        }
        if (!this.agent) {
          this.gtotal = this.ztotal
        }

      } catch (error) {
        console.log(error);
      }
    },
    async xhold_load(offset, limit, page) {

      if (this.xholdevents.length == 0) { await this.xholdevents_load() }
      if (this.xholdclients.length == 0) { await this.xholdclients_load() }
      if (this.xholdagents.length == 0) { await this.xholdagents_load() }

      let state = this.xhold;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      //NO WILDCARD SEARCHES
      if (
        !this.agent && this.slac.length == 0 && this.eventcode.length == 0
      ) {
        this.message = ""
        return;
      }

      state.busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        reference: this.reference.length > 0 ? this.reference.join(",") : null,
        referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
        status: this.status.length > 0 ? this.status.join(",") : null,
        type: this.type.length > 0 ? this.type.join(",") : null,
        datetravel: [
          this.datetravel.startDate
            ? this.$moment(this.datetravel.startDate).format("YYYY-MM-DD")
            : null,
          this.datetravel.endDate
            ? this.$moment(this.datetravel.endDate).format("YYYY-MM-DD")
            : null,
        ],
        agent: this.agent,
        source: 'xhold',
        cost: this.cost.min ? [this.cost.min, this.cost.max] : null,

      };

      try {
        const response = await this.$apollo.query({
          query: gql`
                query ihold(
                  $offset: Int
                  $limit: Int
                  $groupby: String
                  $eventcode: String
                  $slac: String
                  $blac: String
                  $type: String
                  $datetravel: [String]
                  $referenceno: String
                  $reference: String
                  $status: String
                  $source:String
                  $agent: String
                  $cost: [String]
                ) {
                  ihold(
                    offset: $offset
                    limit: $limit
                    groupby: $groupby
                    eventcode: $eventcode
                    slac: $slac
                    blac: $blac
                    type: $type
                    datetravel: $datetravel
                    referenceno: $referenceno
                    reference: $reference
                    status: $status
                    source: $source
                    agent: $agent
                    cost: $cost
                  ) {
                    id
                    referenceno
                    blac                  
                    eventcode
                    eventname
                    slac
                    slacname
                    yourref
                    cost
                    sale
                    vat
                    margin
                    markup
                    total
                    invoiceno
                    posted
                    notes
                    agent
                    lines {
                      id
                      type
                      issued_at
                      last4
                      referenceno                    
                      reference
                      routing
                      remark               
                      locator
                      start_at
                      end_at
                      details
                      description
                      passenger
                      qty
                      sale
                      vat
                      markup
                      total
                      costlocal
                      costlocalcurrency
                      costcurrency                
                      cost
                      blinvoiceno
                      blac
                      slac
                      eventcode
                      margin
                      agent
                      agentname
                      notes
                      expanded
                      claimed
                    }
                    tags
                    data
                    groupby
                    rows
                  }
                }
              `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.ihold
        } else {
          state.items = []
          // STABLE ROW IDENTITY (tp_server#20): key each row by its line ids so
          // e-table keys rows by record, not position - prevents inline-editor
          // state bleeding onto other rows when paging.
          response.data.ihold.forEach(row => {
            let ids = [];
            (row.lines || []).forEach(l => { if (l.id != null) ids.push(l.id); });
            row.uid = [...new Set(ids)].sort().join('-');
          });
          state.items = response.data.ihold;
        }

      } catch (error) {
        console.log(error);
      }

      await this.xholdclients_load()
      await this.xholdagents_load()

      state.busy = false;
    },

    async xhold_click(a, ss, tools) {

      let tool = null

      switch (a) {
        case "filter":
          this.xhold.filter = !this.xhold.filter;
          break;
        case "back":
          this.discard();
          break;
        case "save":
          this.saveit();
          break;
        case "posted":
          this.postit(ss);
          break;
        case "go":
          await this.xhold_reload()
          this.$store.dispatch("xhold");
          break;
        case "ready":
          this.status = ['ready']
          await this.xhold_reload()
          break;
        case "pending":
          this.status = ['pending']
          await this.xhold_reload()
          break;
        case "reset":
          this.status = ['ready']
          this.blac = []
          this.slac = []
          this.eventcode = []
          await this.xhold_reload()
          break;
      }
    },
    async xhold_select(ss, tools) {

      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "export", 'ready', 'pending', 'reset'];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });

        tool = tools.find((o) => o.action == "deleteconfirm");
        if (tool) {
          tool.disabled = ss.length > 0 ? false : true;
        }
        tool = tools.find((o) => o.action == "notes");
        if (tool) {
          tool.disabled = ss.length == 1 ? false : true;
        }
      }

      this.xhold.selected = ss;
    },
    async postit(s) {
      s[0].posted = true
      await this.xholdclients_load()
      this.$store.dispatch("xhold");
    },

  },
};
</script>